import { LAYOUTS, } from '@voltmoney/types';
import { WIDGET, } from '@voltmoney/schema';
import { ROUTE } from '../../../routes';
import { ACTION } from './types';
import { continueAction, goBackAction, needHelpAction } from './actions';
export const template = (height, removePledgeStepsStepperData, netPayable, extraOutstandingBufferBajaj, extraOutstandingBufferDsp) => {
    return {
        layout: {
            id: ROUTE.REMOVE_PLEDGE_STEPS,
            type: LAYOUTS.LIST,
            style: {
                isPartnerPlatform: true
            },
            widgets: [
                { id: "removePledgeStepsDC", type: WIDGET.REMOVE_PLEDGE_STEPS }
            ],
        },
        datastore: {
            removePledgeStepsDC: {
                height: height,
                removePledgeStepperProps: removePledgeStepsStepperData,
                continueAction: {
                    routeId: ROUTE.REMOVE_PLEDGE_STEPS,
                    payload: { netPayable, extraOutstandingBufferBajaj, extraOutstandingBufferDsp },
                    type: ACTION.CONTINUE_ACTION
                },
                goBackAction: {
                    routeId: ROUTE.REMOVE_PLEDGE_STEPS,
                    payload: {},
                    type: ACTION.GO_BACK_ACTION
                },
                needHelpAction: {
                    routeId: ROUTE.REMOVE_PLEDGE_STEPS,
                    payload: {},
                    type: ACTION.NEED_HELP_ACTION
                },
            },
        }
    };
};
export const removePledgeStepsMF = {
    onLoad: async ({ getHeight, instrumentTrack }, { netPayable, extraOutstandingBufferBajaj, extraOutstandingBufferDsp }) => {
        instrumentTrack('REMOVE_PLEDGE_LANDING_PAGE_VIEWED');
        const removePledgeStepsStepperData = [
            {
                "status": "NOT_STARTED",
                "verticalDisplayName": "Select funds and amount",
                "verticalDescription": `Select the funds and specify the amount for which pledge needs to be removed`,
                "order": 0,
                "highLightText": true
            },
            {
                "status": "NOT_STARTED",
                "verticalDisplayName": "Verify using OTP to submit request",
                "verticalDescription": "Lender will verify the request and remove selected funds from your loan account",
                "order": 1,
                "highLightText": true
            },
            {
                "status": "NOT_STARTED",
                "verticalDisplayName": "Track status of your request",
                "verticalDescription": "Your request to unpledge will be shared with SEBI authorised RTAs (CAMS and KFintech). It may take them 4-5 business days to complete unpledging",
                "order": 2,
                "highLightText": true
            },
        ];
        return Promise.resolve(template(getHeight(), removePledgeStepsStepperData, netPayable, extraOutstandingBufferBajaj, extraOutstandingBufferDsp));
    },
    actions: {
        [ACTION.CONTINUE_ACTION]: continueAction,
        [ACTION.GO_BACK_ACTION]: goBackAction,
        [ACTION.NEED_HELP_ACTION]: needHelpAction,
    },
};
